import AbstractWebRtcListenerAction from "~/ts/library/webRtc/comet/AbstractWebRtcListenerAction";
import ListenerMessage from "~/ts/library/listen/ListenerMessage";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallDataUpdate extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallDataUpdate";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallDataUpdateCometMessageOpenApiModel, message: ListenerMessage): void {
        let call: AbstractWebRtcCall | undefined = AbstractWebRtcCall.create(payload.call.id)!;
        call.setCallData(payload.call);
        if (!call.isCallForThisInstance()) {
            call = AbstractWebRtcCall.incomingCalls.value.find(call => payload.call.id == call.getId());
            if (call) {
                call.removeThisCallFromIncoming();
            }
            return;
        }

        let currentCall = AbstractWebRtcCall.getCurrentCall();
        if (currentCall) {
            if (currentCall.getId() == payload.call.id) {
                currentCall.setCallData(payload.call);
            }
        }
    }

}